import React from 'react';
import { Navigate } from 'react-router-dom';
import { useExperiment } from '../../contexts/ExperimentContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { experimentData } = useExperiment();

  // In development mode, allow direct access to all protected pages for testing
  if (process.env.NODE_ENV === 'development') {
    // Log if no experiment data exists
    if (!experimentData || !experimentData.participant) {
      console.warn('Development mode: Allowing direct access to protected route without experiment data');
    }
    return <>{children}</>;
  }

  if (!experimentData || !experimentData.participant) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;